module.exports = __webpack_public_path__ + "img/all_year.7933c55a.png";